import React from 'react';
import { Card } from '@/components/ui/card';
import { Calendar, DollarSign, Users, TrendingUp } from 'lucide-react';

export default function SummaryStatsGrid({ summary }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <Card className="p-6 glass-card">
        <div className="flex items-center gap-3 mb-2">
          <div className="p-3 bg-blue-100 rounded-full">
            <Calendar className="w-6 h-6 text-blue-600" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground uppercase font-bold">Total Bookings</p>
            <p className="text-3xl font-black font-heading">{summary.total_bookings}</p>
          </div>
        </div>
        <div className="mt-3 pt-3 border-t text-xs text-muted-foreground">
          <span className="text-green-600 font-bold">{summary.confirmed_count} Confirmed</span>
          {' • '}
          <span className="text-amber-600 font-bold">{summary.pending_count} Pending</span>
          {' • '}
          <span className="text-red-600 font-bold">{summary.cancelled_count} Cancelled</span>
        </div>
      </Card>

      <Card className="p-6 glass-card">
        <div className="flex items-center gap-3 mb-2">
          <div className="p-3 bg-green-100 rounded-full">
            <DollarSign className="w-6 h-6 text-green-600" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground uppercase font-bold">Total Revenue</p>
            <p className="text-3xl font-black font-heading text-green-600">
              ${summary.total_revenue.toFixed(2)}
            </p>
          </div>
        </div>
        <div className="mt-3 pt-3 border-t text-xs text-muted-foreground">
          Avg: ${summary.average_booking_value.toFixed(2)} per booking
        </div>
      </Card>

      <Card className="p-6 glass-card">
        <div className="flex items-center gap-3 mb-2">
          <div className="p-3 bg-purple-100 rounded-full">
            <Users className="w-6 h-6 text-purple-600" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground uppercase font-bold">Unique Customers</p>
            <p className="text-3xl font-black font-heading">{summary.unique_customers}</p>
          </div>
        </div>
        <div className="mt-3 pt-3 border-t text-xs text-muted-foreground">
          Members & Guests
        </div>
      </Card>

      <Card className="p-6 glass-card">
        <div className="flex items-center gap-3 mb-2">
          <div className="p-3 bg-red-100 rounded-full">
            <TrendingUp className="w-6 h-6 text-red-600" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground uppercase font-bold">Total Discounts</p>
            <p className="text-3xl font-black font-heading text-red-600">
              ${summary.total_discounts.toFixed(2)}
            </p>
          </div>
        </div>
        <div className="mt-3 pt-3 border-t text-xs text-muted-foreground">
          Applied to bookings
        </div>
      </Card>
    </div>
  );
}
